(function () {
  'use strict';

  function initSalonReviews(root) {
    var track = root.querySelector('.salon-reviews__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.salon-reviews__slide'));
    var prevBtn = root.querySelector('.salon-reviews__arrow--prev');
    var nextBtn = root.querySelector('.salon-reviews__arrow--next');
    var dots = Array.prototype.slice.call(root.querySelectorAll('.salon-reviews__dot'));
    var autoplay = root.dataset.autoplay === 'true';
    var autoplaySpeed = (parseInt(root.dataset.autoplaySpeed, 10) || 5) * 1000;
    var autoplayTimer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function updateDots() {
      if (!dots.length) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollByOneCard(direction) {
      var card = slides[0];
      if (!card) return;
      var amount = card.getBoundingClientRect().width + 30;
      track.scrollBy({ left: direction * amount, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByOneCard(-1);
        stopAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByOneCard(1);
        stopAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: reducedMotion ? 'auto' : 'smooth' });
        stopAutoplay();
      });
    });

    var scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        updateArrows();
        updateDots();
        scrollTicking = false;
      });
    });

    function startAutoplay() {
      if (!autoplay || reducedMotion || slides.length < 2) return;
      autoplayTimer = window.setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByOneCard(1);
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('touchstart', stopAutoplay, { passive: true });

    updateArrows();
    updateDots();
    startAutoplay();

    window.addEventListener('resize', function () {
      updateArrows();
      updateDots();
    });
  }

  function initAll() {
    document.querySelectorAll('.salon-reviews').forEach(initSalonReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.salon-reviews');
    if (section) initSalonReviews(section);
  });
})();
